import React, { useState } from 'react';
import { Button, Box, Typography, makeStyles } from '@material-ui/core';
import { HelpCircle } from 'react-feather';
import { HeadlineText } from '../../../../TextVariants';
import { colors } from '../../../../../theme';
import { InstructionsLayout } from '../../../../Composite';
import { renewalMonth } from '../../../../../svg';

const useStyle = makeStyles(() => ({
  images: {
    alignSelf: 'center',
  },
  underInsuranceText: {
    fontWeight: 400,
    fontSize: '15px',
    lineHeight: '1.375rem',
    textAlign: 'justify',
    color: '#0D2E68',
  },
  underInsuranceBox: {
    paddingTop: '15px',
    paddingRight: '25PX',
    paddingLeft: '25px',
    paddingBottom: '8px',
  },
}));

type RenewalMonthHelpProps = {
  iconId: string;
};

const RenewalMonthHelp = ({ iconId }: RenewalMonthHelpProps): JSX.Element => {
  const classes = useStyle();
  const [isOpen, toggleIsOpen] = useState(false);
  return (
    <>
      <HeadlineText style={{ fontSize: '16px' }}>
        Mes de revisado del auto
        <Button
          id={iconId}
          data-testid="button-renewalMonthhelp-help"
          style={{ padding: 0, float: 'right', minWidth: '33px' }}
          onClick={(): void => toggleIsOpen(!isOpen)}
        >
          <HelpCircle
            color={colors.bright_turquoise}
            style={{ justifyContent: 'flex-end' }}
          />
        </Button>
      </HeadlineText>
      <InstructionsLayout
        id="modal-renewalMonthhelphelp"
        project="sales-web"
        data-testid="modal-renewalMonthhelp-help"
        open={isOpen}
        headerTitle="Mes de revisado del auto"
        title={
          <Box display="flex" flexDirection="column" gridRowGap={4}>
            <img
              src={renewalMonth}
              alt="renewalMonthhelp"
              className={classes.images}
            />
          </Box>
        }
        content={
          <Box className={classes.underInsuranceBox}>
            <Typography className={classes.underInsuranceText} paragraph>
              Es el mes en que te corresponde realizar el trámite de revisado y
              renovación de placa.
            </Typography>
            <Typography className={classes.underInsuranceText} paragraph>
              Puedes encontrar esta información en la placa de tu auto. El mes
              de la placa es el mismo para el revisado.
            </Typography>
            <Typography className={classes.underInsuranceText} paragraph>
              Si aún no cuentas con el mes de revisado, puedes colocar el mes
              actual.
            </Typography>
          </Box>
        }
        instructions=""
        onCloseRequested={(): void => toggleIsOpen(!isOpen)}
      />
    </>
  );
};

export default RenewalMonthHelp;
